import { RouteMarker } from './RouteMarker';

type Props = {
  origin: string;
  destination: string;
  timeLabel: string;
};

export function RouteChip({ origin, destination, timeLabel }: Props) {
  return (
    <div className="route-chip">
      <div className="route-chip-points">
        <RouteMarker variant="origin" />
        <span className="route-chip-origin">{origin}</span>
        <RouteMarker variant="dest" />
        <span className="route-chip-dest">{destination}</span>
      </div>
      <span className="route-chip-time">{timeLabel}</span>
    </div>
  );
}
